<template>
    <div>
        <dashboard-tabs :modules="modules">
            <template #primary="{ module }">
              <assessment-actions :module="module" :assessments="assessmentsInModule(module)"></assessment-actions>
            </template>
            <template #secondary="{ module }">
                <div :class="'completed-assessments row container mx-0 p-4 border-'+ module.color +' border-top-0'" 
                        v-if="assessmentsInModule(module).length && assessmentsInModule(module).some(assessment => assessment.status === 'Completed')"
                >
                    <div class="col-12">
                        <h2 class="landing mb-4">View Completed Self-Assessments</h2>
                        <template v-for="assessment in assessmentsInModule(module)">
                            <div class="icon-name-view row mx-0" :key="assessment.id" v-if="assessment.status == 'Completed'">
                                <div class="col-sm-6 p-0 align-middle">
                                    <a :href="$basePath+'/self-assessments/'+module.slug+'/'+assessment.id+'/results'">
                                        <module-icon :module-slug="module.slug" size="md" class="module-icon"></module-icon>
                                        <span class="module-name">{{ module.name }}</span>
                                    </a>
                                </div>
                                <div class="col-sm-6 p-0 text-sm-right align-middle">
                                    <a :href="$basePath+'/self-assessments/'+module.slug+'/'+assessment.id+'/results'" class="module-status-link">
                                        <span class="module-status">{{ assessment.status }} {{ formatDate(assessment.finalized_at) }}</span>
                                    </a>
                                </div>
                            </div><!-- .row -->
                        </template>
                    </div><!-- .col-12 -->
                </div>
            </template>
        </dashboard-tabs>
    </div>
</template>

<script>
    import ModuleIcon from './ModuleIcon'
    import DashboardTabs from './dashboard_tabs/DashboardTabs'
    import ContentContainer from './dashboard_tabs/ContentContainer'
    import AssessmentActions from './assessments/AssessmentActions'
    import moment from 'moment'

	export default{
        components: {
            ContentContainer,
            AssessmentActions,
            ModuleIcon,
            DashboardTabs,
            moment
        },
        props: {
            modules: {
                required: true,
                type: Array
            },
            assessments: {
                required: true,
                type: Array
            }
        },
		data(){
			return {
			}
		},
		methods: {
            assessmentsInModule(module) {
                if (this.assessments) {
                    return this.assessments.filter(asmnt => {
                        return asmnt.survey.module_id == module.id
                    })
                }
            },
            formatDate: function (value) {
                if (value) {
                    return moment(String(value)).format('MM/DD/YY')
                }
            },
		},
        computed: {
        },
		mounted: function(){
		}
	}
</script>